// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"744":"adc77800","821":"cc5ad5a0"}[chunkId] + ".js";
};